import { NgModule } from '@angular/core';
import { BaseAuthWrapperComponent } from './_components/base-auth-wrapper/base-auth-wrapper.component';
import { BaseRegisterFormComponent } from './_components/base-register-form/base-register-form.component';
import { BaseLoginFormComponent } from './_components/base-login-form/base-login-form.component';
import { BaseResetPasswordComponent } from './_components/base-reset-password/base-reset-password.component';
import { BaseRegistrationVerificationComponent } from './_components/base-registration-verification/base-registration-verification.component';
import { BaseSharedModule } from '../../shared/base-shared.module';
import { AppsSharedModule } from '../../apps-shared/apps-shared.module';

@NgModule({
  imports: [BaseSharedModule, AppsSharedModule],
  declarations: [
    BaseAuthWrapperComponent,
    BaseRegisterFormComponent,
    BaseLoginFormComponent,
    BaseResetPasswordComponent,
    BaseRegistrationVerificationComponent,
  ],
  exports: [
    BaseAuthWrapperComponent,
    BaseRegisterFormComponent,
    BaseLoginFormComponent,
    BaseResetPasswordComponent,
    BaseRegistrationVerificationComponent,
  ],
})
export class BaseAuthModule {}
